import { createTheme } from '@mui/material/styles'

declare module '@mui/material/styles' {
  interface Palette {
    tab: {
      unselected: string
    }
  }
  interface PaletteOptions {
    tab?: {
      unselected?: string
    }
  }
}

const sharedConfig = {
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06)',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          '&::-webkit-scrollbar': {
            width: '6px',
            height: '6px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: '3px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: '#a8a8a8',
          },
        },
      },
    },
  },
}

export const lightTheme = createTheme({
  ...sharedConfig,
  palette: {
    mode: 'light',
    primary: {
      main: '#1565c0',
      light: '#5e92f3',
      dark: '#003c8f',
    },
    secondary: {
      main: '#7b1fa2',
      light: '#ae52d4',
      dark: '#4a0072',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    tab: {
      unselected: '#e3f2fd',
    },
  },
  components: {
    ...sharedConfig.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#212121',
        },
      },
    },
  },
})

export const darkTheme = createTheme({
  ...sharedConfig,
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
      light: '#e3f2fd',
      dark: '#42a5f5',
    },
    secondary: {
      main: '#ce93d8',
      light: '#f3e5f5',
      dark: '#ab47bc',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    tab: {
      unselected: '#333333',
    },
  },
  components: {
    ...sharedConfig.components,
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e1e1e',
          color: '#e0e0e0',
        },
      },
    },
  },
})

export const blueTheme = createTheme({
  ...sharedConfig,
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
      light: '#63a4ff',
      dark: '#004ba0',
    },
    secondary: {
      main: '#ff6f00',
      light: '#ffa040',
      dark: '#c43e00',
    },
    background: {
      default: '#e8eaf6',
      paper: '#ffffff',
    },
    tab: {
      unselected: '#e3f2fd',
    },
  },
  components: {
    ...sharedConfig.components,
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRight: '1px solid #c5cae9',
        },
      },
    },
  },
})

export const themes: Record<string, ReturnType<typeof createTheme>> = {
  light: lightTheme,
  dark: darkTheme,
  blue: blueTheme,
}

export const theme = lightTheme
